module.exports = __webpack_public_path__ + "img/index-product-scan-blue.a4df2591.png";